import React from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";

import "../assets/css/sideDrawer.css";

const SideDrawer = (props) => {
  const handleEntered = () => {
    const firstFocusable = document.querySelector(
      ".side-drawer a, .side-drawer button"
    );
    firstFocusable?.focus();
  };

  const content = (
    <CSSTransition
      in={props.show}
      timeout={200}
      classNames="slide-in-left"
      mountOnEnter
      unmountOnExit
      onEntered={handleEntered}
    >
      <aside className="side-drawer">
        {props.children}
      </aside>
    </CSSTransition>
  );

  return ReactDOM.createPortal(content, document.getElementById("drawer-hook"));
};

export default SideDrawer;
